import { useEffect, useState } from "react";
import { getDisplayName, getInitials, getItemId, getUserEmail } from "../../shared/utils/officeHelpers";

export default function useOfficeContext() {
  const [officeContext, setOfficeContext] = useState(() => {
    const displayName = getDisplayName();

    return {
      displayName,
      initials: getInitials(displayName),
      userEmail: getUserEmail(),
      itemId: getItemId(),
    };
  });

  useEffect(() => {
    if (typeof Office === "undefined" || !Office.context?.mailbox) {
      return undefined;
    }

    const mailbox = Office.context.mailbox;

    const syncOfficeContext = () => {
      const displayName = getDisplayName();

      setOfficeContext({
        displayName,
        initials: getInitials(displayName),
        userEmail: getUserEmail(),
        itemId: getItemId(),
      });
    };

    mailbox.addHandlerAsync(Office.EventType.ItemChanged, syncOfficeContext);
    syncOfficeContext();

    return () => {
      mailbox.removeHandlerAsync(Office.EventType.ItemChanged, syncOfficeContext);
    };
  }, []);

  return officeContext;
}
